import React from "react";

function UploadFile({ width = 21, height = 21, fill = "#F8F6F6" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_22626)">
        <path
          d="M12.1667 2.16663H5.49999C4.58333 2.16663 3.84166 2.91663 3.84166 3.83329L3.83333 17.1666C3.83333 18.0833 4.57499 18.8333 5.49166 18.8333H15.5C16.4167 18.8333 17.1667 18.0833 17.1667 17.1666V7.16663L12.1667 2.16663ZM15.5 17.1666H5.49999V3.83329H11.3333V7.99996H15.5V17.1666ZM7.16666 13.0083L8.34166 14.1833L9.66666 12.8666V16.3333H11.3333V12.8666L12.6583 14.1916L13.8333 13.0083L10.5083 9.66663L7.16666 13.0083Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_7_22626">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UploadFile;
